<footer class="main-footer">
    <div class="float-right d-none d-sm-block"><b>Versione</b> 1.0.18</div>
    <strong
      >Copyright &copy; 2024
      <a href="https://www.thnet.it/">THnet</a>.</strong
    >
    All rights reserved.
  </footer>
  